import script from "./RegionPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegionPicker.vue?vue&type=script&lang=ts&setup=true"

import "./RegionPicker.vue?vue&type=style&index=0&id=4a1e2840&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a1e2840"]])

export default __exports__